class LandwerkTheme {
  constructor() {
    this.menu = document.querySelector('[data-mobile-menu]');
    this.overlay = document.querySelector('[data-menu-overlay]');
    this.bindMenu();
    this.bindQuantity();
    this.bindProductForms();
    this.bindSort();
    this.loadRecommendations();
  }

  bindMenu() {
    const openButton = document.querySelector('[data-menu-open]');
    const closeButton = document.querySelector('[data-menu-close]');
    if (!this.menu || !openButton || !closeButton || !this.overlay) return;

    const open = () => {
      this.menu.classList.add('is-open');
      this.menu.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      this.overlay.hidden = false;
      document.body.classList.add('menu-open');
      closeButton.focus();
    };

    const close = () => {
      this.menu.classList.remove('is-open');
      this.menu.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      this.overlay.hidden = true;
      document.body.classList.remove('menu-open');
      openButton.focus();
    };

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    this.overlay.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.menu.classList.contains('is-open')) close();
    });
  }

  bindQuantity() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-button]');
      if (!button) return;
      const wrapper = button.closest('[data-quantity]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const direction = button.dataset.quantityButton;
      const step = Number(input.step || 1);
      const minimum = Number(input.min || 0);
      const next = direction === 'plus' ? Number(input.value) + step : Number(input.value) - step;
      input.value = Math.max(minimum, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  bindProductForms() {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const optionSelects = [...root.querySelectorAll('[data-option-select]')];
      const variantInput = root.querySelector('input[name="id"]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const price = root.querySelector('[data-product-price]');
      const variantDataElement = root.querySelector('[data-variant-json]');
      if (!optionSelects.length || !variantInput || !variantDataElement) return;

      let variants = [];
      try { variants = JSON.parse(variantDataElement.textContent); } catch (error) { return; }

      const updateVariant = () => {
        const selectedOptions = optionSelects.map((select) => select.value);
        const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        if (price) price.innerHTML = this.formatMoney(variant.price);
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.querySelector('span').textContent = variant.available ? 'Legg i handlekurven' : 'Utsolgt';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };

      optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
    });
  }

  formatMoney(cents) {
    const currency = document.documentElement.dataset.currency || 'NOK';
    return new Intl.NumberFormat(document.documentElement.lang || 'nb-NO', {
      style: 'currency',
      currency,
    }).format(cents / 100);
  }

  bindSort() {
    document.querySelectorAll('[data-sort-by]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
  }

  loadRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach(async (element) => {
      const url = element.dataset.url;
      if (!url) return;
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.querySelector('[data-product-recommendations]');
        if (replacement && replacement.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
      } catch (error) {
        element.hidden = true;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new LandwerkTheme());
